import Link from 'next/link';
import Image from 'next/image';
import { addBaseUrl, removeBaseUrl } from '@/utils/url';
import { WagtailPage, WagtailStreamfieldImage } from '@/types';
import RawHtml from '@components/RawHtml';

interface LinkTile {
  title: string;
  button_page: WagtailPage | null;
  button_url: string | null;
  image: WagtailStreamfieldImage | null;
  svg: string | null;
  tag: string | null;
}

interface Props {
  link_kacheln: LinkTile[];
}

function Links(props: Props) {
  const { link_kacheln: linkKachel } = props;

  return (
    <div className='streamfield links'>
      {linkKachel.map(tile => (
        <Link
          key={tile.title}
          href={
            tile.button_page ? removeBaseUrl(tile.button_page.full_url) : (tile.button_url ?? '/')
          }
          passHref
          className='links__tile'
        >
          <div className='title'>{tile.title}</div>
          {tile.tag ? <div className='links__tile-tag'>{tile.tag}</div> : null}
          {tile.image && !tile.svg ? (
            <div className='links__icon-image-container'>
              <Image
                src={addBaseUrl(tile.image.file.src)}
                alt={tile.image.file.alt}
                layout='intrinsic'
                objectFit='contain'
                className='icon'
                width={78}
                height={78}
              />
            </div>
          ) : null}
          {tile.svg ? <RawHtml className='icon' html={tile.svg} /> : null}
        </Link>
      ))}
    </div>
  );
}

export default Links;
